export default {
  routes: [
    {
      path: '/fast-sale',
      name: 'fast-sale',
      meta: {
        desc: '一键转卖',
        pageId: 'S7195'
      },
      component: () => import(/* webpackChunkName: "Collection" */ '../views/fastSale/index.vue')
    }
  ]
}
